import React, { Component } from 'react';
import PropTypes from 'prop-types';


import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    ml: 1,
    mr: 1,
    //width: 200,
  },
  hide:{
    display:'none',
  },
};

class FTextArea extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value
    };
  }

  handleChange = (event:any) => {
    const {onChange} = this.props;
    let value = event.target.value;
    if(typeof onChange === 'function') onChange(value);
    this.setState({value});
  };

  render() {
    const {id,label,options,divider,classes } = this.props;

    return (
      // <Box sx={{...s.root}}>
      <React.Fragment>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            multiline={true}
            minRows={1}
            // maxRows={3}
            {...options}
            fullWidth={true}
            sx={{...s.textField}}
            value={this.state.value}
            onChange={this.handleChange}
          />
        {divider && <Divider />}
      </React.Fragment>
      // </Box>
    );
  }
}

FTextArea.propTypes = {
  //classes: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  //label: PropTypes.string.isRequired,
};

export default FTextArea;
